module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Quick Email")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right box-tools"
  }, [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "name": "emailto",
      "placeholder": "Email to:"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "subject",
      "placeholder": "Subject"
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    staticClass: "textarea",
    staticStyle: {
      "width": "100%",
      "height": "125px",
      "font-size": "14px",
      "line-height": "18px",
      "border": "1px solid #dddddd",
      "padding": "10px"
    },
    attrs: {
      "placeholder": "Message"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('button', {
    staticClass: "pull-right btn btn-default",
    attrs: {
      "type": "button",
      "id": "sendEmail"
    }
  }, [_vm._v("Send\n      "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0934b98b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VAQuickMail.vue
// module id = 667
// module chunks = 0